import { render, staticRenderFns } from "./ConfirmEmailRegistrationView.vue?vue&type=template&id=1754e00a&scoped=true&"
import script from "./ConfirmEmailRegistrationView.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailRegistrationView.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailRegistrationView.vue?vue&type=style&index=0&id=1754e00a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754e00a",
  null
  
)

export default component.exports